export const isValidLanguage = (language: string) => {
  return language === 'en' || language === 'zh';
};

export const getDefaultLanguage = () => {
  return 'en';
};
